(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('PersonAdministrationController', PersonAdministrationController);

    PersonAdministrationController.$inject = [
        '$q',
        '$scope',
        '$state',
        '$rootScope',
        '$kWindow',
        '$translate',
        'kendoUtility',
        'formTypes',
        'commonUtility',
        'personService',
        'locationService',
        'contractorService',
        'htmlElementService',
        'sanitizeService',
        'authService'
    ];

    function PersonAdministrationController(
        $q,
        $scope,
        $state,
        $rootScope,
        $kWindow,
        $translate,
        kendoUtility,
        formTypes,
        commonUtility,
        personService,
        locationService,
        contractorService,
        htmlElementService,
        sanitizeService,
        authService
    ) {
        const defaultGroupFilter = [];

        var canChangeState = false;
        var langId = localStorage['NG_TRANSLATE_LANG_KEY'];
        $scope.isSuperUser = $rootScope.authData.isSuperuser;
        $scope.canDeletePerson = $scope.isSuperUser || authService.hasPermission('AdministrationView');

        window.onbeforeunload = function () {
            if ($('#persons-administration-grid').data('kendoGrid').dataSource.hasChanges()) {
                return $translate.instant('G_UNSAVED_CHANGES_WARNING', null, null, langId);
            }
        };

        $scope.$on('$stateChangeStart', function (event, next) {
            if (!canChangeState && !event.defaultPrevented && $('#persons-administration-grid').data('kendoGrid').dataSource.hasChanges()) {
                event.preventDefault();

                var windowInstance = $kWindow.open({
                    options: {
                        modal: true,
                        movable: false,
                        resizable: false,
                        visible: false,
                        width: 300
                    },
                    templateUrl: 'app/shared/popups/confirm-modal.html',
                    windowTemplateUrl: 'app/shared/modal-base.html',
                    controller: 'ConfirmModalController',
                    resolve: {
                        content: function () {
                            return $translate.instant('G_UNSAVED_CHANGES_WARNING', null, null, langId);
                        },
                        primaryBtnText: function () {
                            return null;
                        },
                        secondaryBtnText: function () {
                            return null;
                        }
                    }
                });
                windowInstance.result.then(function (response) {
                    if (response) {
                        canChangeState = response;
                        $state.go(next.name);
                    }
                });
            }
        });


        var personsAdministrationDataSource = new kendo.data.DataSource({
            transport: {
                read: e => e.success($scope.persons),
                update: e => onPersonsGridUpdate(e)
            },
            toolbar: ['save', 'cancel'],
            group: defaultGroupFilter,
            schema: {
                model: {
                    id: 'personId',
                    fields: {
                        firstName: { editable: true },
                        lastName: { editable: true },
                        email: { editable: true },
                        phoneNumber: { editable: true },
                        mobilePhoneNumber: { editable: true },
                        externalId: { editable: true },
                        locationPersons: { editable: true },
                        contractorName: { editable: false },
                    }
                },
            }
        });

        const personsAdministrationGridOptions = (langId, includeConglomerate) => ({
            dataSource: personsAdministrationDataSource,
            height: kendoUtility.calculateRemainingSpace(-40),
            columns: [
                {
                    field: 'personId',
                    hidden: true
                },
                {
                    field: 'firstName',
                    title: $translate.instant('ADMIN_PERSONS_FIRST_NAME', null, null, langId),
                    template: function (dataItem) {
                        if (dataItem.dirty) {
                            toggleChangesButtons(false);
                        }
                        return dataItem.firstName ? dataItem.firstName : '';
                    },
                },
                {
                    field: 'lastName',
                    title: $translate.instant('ADMIN_PERSONS_LAST_NAME', null, null, langId),
                    template: function (dataItem) {
                        if (dataItem.dirty) {
                            toggleChangesButtons(false);
                        }
                        return dataItem.lastName ? dataItem.lastName : '';
                    },
                },
                {
                    field: 'email',
                    title: $translate.instant('ADMIN_PERSONS_EMAIL', null, null, langId),
                    template: function (dataItem) {
                        if (dataItem.dirty) {
                            toggleChangesButtons(false);
                        }
                        return dataItem.email ? dataItem.email : '';
                    },
                },
                {
                    field: 'phoneNumber',
                    title: $translate.instant('ADMIN_PERSONS_PHONE_NUMBER', null, null, langId),
                    template: function (dataItem) {
                        if (dataItem.dirty) {
                            toggleChangesButtons(false);
                        }
                        return dataItem.phoneNumber ? dataItem.phoneNumber : '';
                    },
                },
                {
                    field: 'mobilePhoneNumber',
                    title: $translate.instant('ADMIN_PERSONS_MOBIL_NUMBER', null, null, langId),
                    template: function (dataItem) {
                        if (dataItem.dirty) {
                            toggleChangesButtons(false);
                        }
                        return dataItem.mobilePhoneNumber ? dataItem.mobilePhoneNumber : '';
                    },
                },
                {
                    field: 'externalId',
                    title: $translate.instant('ADMIN_PERSONS_EXTERNAL_ID', null, null, langId),
                    template: function (dataItem) {
                        if (dataItem.dirty) {
                            toggleChangesButtons(false);
                        }
                        return dataItem.externalId ? dataItem.externalId : '';
                    },
                },
                {
                    field: 'contractorName',
                    title: $translate.instant('ADMIN_PERSONS_COMPANY', null, null, langId),
                    hidden: !includeConglomerate,
                    width: 200,
                    template: function (dataItem) {
                        return dataItem.contractorName ? dataItem.contractorName : '';
                    },
                    filterable: {
                        search: true,
                        field: "contractorName",
                        extra: false
                    },
                },
                {
                    field: 'locations',
                    dataValueField: "locationNames",
                    title: $translate.instant('ADMIN_PERSONS_LOCATIONS', null, null, langId),
                    template: function (dataItem) {
                        if (dataItem.dirty) {
                            var locationNames = ''
                            _.forEach(dataItem.locations, function (location) {
                                locationNames = locationNames + location.name + ", "
                            });
                            dataItem.locationNames = locationNames.substr(0, locationNames.length - 2)
                            toggleChangesButtons(false);
                        }
                        return dataItem.locationNames ? dataItem.locationNames : '';
                    },
                    width: 300,
                    editor: locationPersonsDropDownEditor,
                    filterable: {
                        search: true,
                        field: "locationNames",
                        extra: false
                    },
                },
                {
                    command: gridCommands(),
                    width: 100,
                }
            ],
            editable: true,
            save: function (e) {
                $scope.$applyAsync(function () {
                   sanitizeService.sanitizingGridContent(e);
               });
           },
            filterable: true,
            resizable: true,
            sortable: true,
            groupable: true,
            group: groupOnFieldsOrObject
        });

        $scope.includeConglomerate = false;
        $scope.showConglomerateToggle = false;
        $scope.conglomerateContractors = [];
        $scope.personsAdministrationGridOptions = personsAdministrationGridOptions($translate.use(), $scope.includeConglomerate);
        $scope.persons = [];
        $scope.locations = [];
        $scope.addNewPerson = addNewPerson;
        $scope.saveChanges = saveChanges;
        $scope.cancelChanges = cancelChanges;
        $scope.editPerson = editPerson;
        $scope.groupOnFieldsOrObject = groupOnFieldsOrObject;
        $scope.toggleConglomerate = toggleConglomerate;

        $scope.toggleChangesButtons = toggleChangesButtons;
        $scope.$on('langChanged', (event, code) => {
            $scope.personsAdministrationGridOptions = personsAdministrationGridOptions(code, $scope.includeConglomerate);
            const grid = kendoUtility.createWidget('kendoGrid', $scope.personsAdministrationGridOptions);
            kendoUtility.changeLangOfWidget(code, [() => grid('#persons-administration-grid')]);
            langId = code;
        });

        function gridCommands() {
            var commands = [
                {
                    name: 'editPerson',
                    click: e => editPerson(e),
                    template: '<a class="k-grid-editPerson"><i class="fas fa-edit"></i></a>'
                }
            ];

            if ($scope.canDeletePerson) {
                commands.push({
                    name: 'deletePerson',
                    click: function (e) {
                        e.preventDefault();
                        const tr = $(e.target).closest('tr');
                        const data = this.dataItem(tr).toJSON();
                        deletePerson(data.personId);
                    },
                    template: '<a class="k-grid-deletePerson"><i class="fas fa-trash"></i></a>'
                });
            }

            return commands;
        }

        function groupOnFieldsOrObject(e) {
            if (e.groups.length) {
                var isObjectGrouped;
                // can add more fields to this array if there are more object fields to group on in the grid
                var objectFields = [{ gridField: 'locations', groupByField: 'locationNames' }];

                // check if any of the object fields are in the grouped fields
                e.groups.map(gf => {
                    if (objectFields.map(x => x.gridField).includes(gf.field)) {
                        isObjectGrouped = true;
                    }
                })

                if (isObjectGrouped) {
                    e.preventDefault()
                    var newGroups = [];
                    this.dataSource.group().forEach(gf => {
                        if (!objectFields.map(x => x.gridField).includes(gf.field)) {
                            //add all except the object fields as they are
                            newGroups.push(gf)
                        }
                    })
                    // then add the desired field names for object fields
                    objectFields.forEach(obj => {
                        newGroups.push({ field: obj.groupByField })
                    });
                    this.dataSource.group(newGroups)
                }
            }
        }

        initController();
        function initController() {
            htmlElementService.checkIfElementExists("filter-group")
            .then(function (result) {
                commonUtility.calculateAdminTabMenuWidth();
            });

            contractorService.getContractorsWithinConglomerate($rootScope.authData.contractorId)
                .then(contractors => {
                    // superusers get back every contractor from this endpoint, not just conglomerate siblings,
                    // so narrow it down to contractors that actually share our own conglomerateId
                    var ownContractor = _.find(contractors, { contractorId: $rootScope.authData.contractorId });
                    var ownConglomerateId = ownContractor ? ownContractor.conglomerateId : null;
                    $scope.conglomerateContractors = ownConglomerateId
                        ? (contractors || []).filter(c => c.conglomerateId === ownConglomerateId)
                        : (ownContractor ? [ownContractor] : []);
                    $scope.showConglomerateToggle = $scope.conglomerateContractors.length > 1;
                })
                .catch(error => console.error(error));

            loadPersonsAndLocations();
        }

        function loadPersonsAndLocations() {
            $rootScope.$broadcast('showBusyIndicator', {
                id: 'personsAdministrationGrid',
                destination: '#persons-administration-grid'
            });
            toggleChangesButtons(true)
            let requests = {};
            requests.getPersons = personService.getContactPersonsByContractorId($scope.includeConglomerate);
            requests.getLocationsWebApi = locationService.getLocationsWebApi($rootScope.authData.contractorId, $scope.includeConglomerate);
            $q.all(requests)
                .then(data => {
                    $scope.locations = data.getLocationsWebApi;
                    _.forEach(data.getPersons, function (item) {
                        extendPerson(item);
                    });

                    $scope.persons = data.getPersons.sort(comparePersons);
                })
                .catch(error => console.error(error))
                .finally(() => {
                    $scope.personsAdministrationGridOptions.dataSource.read();
                    $rootScope.$broadcast('hideBusyIndicator', 'personsAdministrationGrid');
                });
        }

        function toggleConglomerate() {
            $scope.personsAdministrationGridOptions = personsAdministrationGridOptions(langId, $scope.includeConglomerate);
            const grid = kendoUtility.createWidget('kendoGrid', $scope.personsAdministrationGridOptions);
            grid('#persons-administration-grid');
            loadPersonsAndLocations();
        }

        function extendPerson(item) {
            item.contractorName = item.contractor ? item.contractor.name : '';
            if (item.locationPersons && item.locationPersons.length) {
                var locations = [];
                var locationNames = '';
                _.forEach(item.locationPersons, function (locationPerson) {
                    var location = $scope.locations.find(obj => {
                        return obj.locationNumber == locationPerson.locationNumber
                    });
                    if (location) {
                        locations.push(location);
                        locationNames = locationNames + location.name + ", "
                    }
                });
                item.locationNames = locationNames.substr(0, locationNames.length - 2)
                item.locations = locations
            } else {
                item.locations = [];
                item.locationNames = '';
            }
        }

        function comparePersons(a, b) {
            return (a.lastName || '').localeCompare(b.lastName || '', 'nb-NO', { sensitivity: 'base' })
                || (a.firstName || '').localeCompare(b.firstName || '', 'nb-NO', { sensitivity: 'base' })
                || (a.email || '').localeCompare(b.email || '', 'nb-NO', { sensitivity: 'base' })
                || (a.locationNames || '').localeCompare(b.locationNames || '', 'nb-NO', { sensitivity: 'base' });
        }

        function locationPersonsDropDownEditor(container, options) {
            $('<select name="' + options.field + '"></select>').appendTo(container).kendoMultiSelect({
                dataTextField: "name",
                dataValueField: "locationNumber",
                dataSource: {
                    data: _.orderBy($scope.locations,'name')
                },
            });
        }

        function openPersonWindow(currentFormType, person) {
            var windowInstance = $kWindow.open({
                options: {
                    modal: true,
                    movable: false,
                    title: $translate.instant('ADMIN_PERSONS_ADD_PERSON'),
                    resizable: true,
                    width: 520,
                    visible: false
                },
                templateUrl: 'app/administration/persons/person-details-modal-administration-view.html',
                windowTemplateUrl: 'app/shared/modal-base.html',
                controller: 'personDetailsModalAdministrationController',
                resolve: {
                    currentFormType: () => currentFormType,
                    person: () => person,
                    locations: () => $scope.locations,
                    contractors: () => $scope.conglomerateContractors,
                    includeConglomerate: () => $scope.includeConglomerate,
                }
            });

            windowInstance.result.then(function (result) {
                if (result) {
                    extendPerson(result)
                    if (currentFormType == formTypes.add) {
                        $scope.persons = $scope.persons.concat([result]);
                    } else {
                        $scope.persons = $scope.persons.map(u => (u.personId === result.personId ? result : u));
                    }
                    $scope.personsAdministrationGridOptions.dataSource.read();
                }
            });
        }

        function addNewPerson() {
            openPersonWindow(formTypes.add, null)
        }

        function editPerson(event) {
            var person = getPersonFromGrid(event)
            openPersonWindow(formTypes.edit, person)
        }

        function deletePerson(personId){
            var windowInstance = $kWindow.open({
                options: {
                    modal: true,
                    movable: false,
                    resizable: false,
                    visible: false,
                    width: 300
                },
                templateUrl: 'app/shared/popups/confirm-modal.html',
                windowTemplateUrl: 'app/shared/modal-base.html',
                controller: 'ConfirmModalController',
                resolve: {
                    content: function () {
                        return $translate.instant('G_CONFIRM_DELETE', null, null);
                    },
                    primaryBtnText: function () {
                        return null;
                    },
                    secondaryBtnText: function () {
                        return null;
                    }
                }
            });
            windowInstance.result.then(function (response) {
                if (response) {
                    $rootScope.$broadcast('showBusyIndicator', {
                        id: 'personsAdministrationGrid',
                        destination: '#persons-administration-grid'
                    });

                    personService.deletePerson(personId).then(function(){
                        $scope.persons = $scope.persons.filter(x => x.personId != personId);
                        $scope.personsAdministrationGridOptions.dataSource.read();
                    }).finally(function(){
                        $rootScope.$broadcast('hideBusyIndicator', 'personsAdministrationGrid');
                    });
                }
            });
        }

        function getPersonFromGrid(event) {
            const sender = event.currentTarget;
            const row = angular.element(sender).closest('tr');
            return $('#persons-administration-grid')
                .data('kendoGrid')
                .dataItem(row)
                .toJSON();
        }

        function saveChanges() {
            $scope.personsAdministrationGridOptions.dataSource.sync();
        }

        function cancelChanges() {
            toggleChangesButtons(true)
            $scope.personsAdministrationGridOptions.dataSource.read();
        }

        function toggleChangesButtons(disabled) {
            var saveChangesButton = $('button.k-button.k-grid-save-changes-persons');
            var cancelChangesButton = $('button.k-button.k-grid-cancel-changes-persons');
            if (disabled) {
                saveChangesButton.prop('disabled', true);
                saveChangesButton.addClass('k-state-disabled');
                cancelChangesButton.prop('disabled', true);
                cancelChangesButton.addClass('k-state-disabled');
            } else {
                saveChangesButton.prop('disabled', false);
                saveChangesButton.removeClass('k-state-disabled');
                cancelChangesButton.prop('disabled', false);
                cancelChangesButton.removeClass('k-state-disabled');
            }
        }

        function mapLocationPersonObjects(item) {
            if (item.locations && item.locations.length) {
                var locationPersons = [];
                _.forEach(item.locations, function (location) {
                    var locationPerson = {};
                    locationPerson.locationNumber = location.locationNumber;
                    locationPerson.personId = item.personId;

                    locationPersons.push(locationPerson);
                });
                item.locationPersons = locationPersons
            }
        }

        function onPersonsGridUpdate(e) {
            $rootScope.$broadcast('showBusyIndicator', {
                id: 'personsAdministrationGrid',
                destination: '#persons-administration-grid'
            });
            mapLocationPersonObjects(e.data)
            personService.updatePerson(e.data)
                .then(function (response) {
                    if (response) {
                        toggleChangesButtons(true);
                        e.success();
                        $rootScope.$broadcast('hideBusyIndicator', 'personsAdministrationGrid');
                    } else {
                        e.error();
                        $rootScope.$broadcast('hideBusyIndicator', 'personsAdministrationGrid');
                    }
                }, function (error) {
                    e.error(error);
                    $rootScope.$broadcast('hideBusyIndicator', 'personsAdministrationGrid');
                });

        }
    }
})();
